export const emptyBuilding = {
  name: "",
  addressText: "",
  fiasAddressId: "",
  organizationMainId: null,
  organizationMainName: "",
  ownershipTypeId: null,
  funcTypeGroupId: null,
  isRoom: true,
  startExplYear: null,
  totalArea: "",
  effectiveArea: "",
  heatedArea: "",
};

export const emptyOrganization = {
  id: null,
  name: "",
  label: "",
  inn: "",
  grbsId: null,
  isGrbs: false,
  isRso: false,
  gridTypeIds: [],
  ogrn: "",
  hasSpPermission: false,
};
